import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=a03aa3e8&lang=html&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "../../../../shared-components/toolbar/Toolbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/shared-components/toolbar/Toolbar.vue
// module id = 938
// module chunks = 28